import { Button, Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react'
import { IoChevronDownSharp } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ShippinglabelAdmin from '../../pages/ShippinglabelAdmin';
import { supabase } from '../../supabase.config';

const ViewOrderDetails = ({ goBack, orderDetails, generateForwardingNumber, loadingPod, handleUpdateModal, addPOD, id }) => {
    const { error, loading, isAuthenticated, users, userProfile } = useSelector(
        (state) => state.user
    );
    const [totalBox, setTotalBox] = useState(0)
    const [showLabel, setShowLabel] = useState(false)

    const navigate = useNavigate()

    console.log(orderDetails)

    const getBoxes = () => {

        let totalBoxes = 0
        orderDetails?.dimensions?.map((d) => {
            totalBoxes = Number(totalBoxes) + Number(d?.count)

        })
        return totalBoxes
        console.log(totalBoxes)


    }

    const Openlabel = () => {
        setShowLabel(true)
    }

    useEffect(() => {

        getBoxes()
    }, [])

    console.log(id)

    const deleteOrder = async () => {
        try {
            const { error } = await supabase.from('orders').delete().eq('id', id)
            if (error) throw error
            navigate("/orders");
        } catch (error) {
            console.error("Failed to delete order:", error);
        }
    };
    const getStatusColor = (status) => {
        const s = String(status || '').toLowerCase()
        if (s === 'delivered') return 'bg-green-100 text-green-800 border-green-200'
        if (s === 'in-transit') return 'bg-orange-100 text-orange-800 border-orange-200'
        if (s === 'pickedup' || s === 'picked up') return 'bg-purple-100 text-purple-800 border-purple-200'
        if (s === 'new') return 'bg-yellow-100 text-yellow-800 border-yellow-200'
        if (s === 'undelivered') return 'bg-red-100 text-red-800 border-red-200'
        return 'bg-gray-100 text-gray-800 border-gray-200'
    }

    return (
        <>
            <div className='mx-4 md:mx-6 lg:mx-8 py-6' >
                {/* Header Section */}
                <div className='bg-white rounded-xl shadow-md border border-gray-100 p-6 mb-6' >
                    <div className='flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4' >
                        <div>
                            <h1 className='text-2xl md:text-3xl font-[GilroyBold] text-gray-800 mb-1'>Order Details</h1>
                            <p className='text-sm text-gray-600'>LR Number: <span className='font-[GilroyBold] text-black'>{orderDetails?.lrno || 'N/A'}</span></p>
                        </div>
                        <div className='flex items-center gap-3 flex-wrap'>
                            {userProfile?.role === "admin" && (
                                <>
                                    <Link to={`/editorder/${id}`}>
                                        <Button className='bg-[#FFB200] hover:bg-[#e6a000] text-black font-[GilroyMedium]'>
                                            Edit Order
                                        </Button>
                                    </Link>
                                    <Button 
                                        onClick={() => {
                                            if (window.confirm('Are you sure you want to delete this order?')) {
                                                deleteOrder()
                                            }
                                        }}
                                        className='bg-red-600 hover:bg-red-700 text-white font-[GilroyMedium]'
                                    >
                                        Delete Order
                                    </Button>
                                </>
                            )}
                            <Menu placement="bottom-end">
                                <MenuHandler>
                                    <Button className="bg-black hover:bg-gray-800 text-white flex items-center gap-2 font-[GilroyMedium]">
                                        <span>Print</span>
                                        <IoChevronDownSharp />
                                    </Button>
                                </MenuHandler>
                                <MenuList>
                                    <Link to={`/orderDetails/waybill/${id}`}>
                                        <MenuItem className='flex items-center gap-2'>
                                            Download Waybill
                                        </MenuItem>
                                    </Link>
                                    <Link to={`/orderDetails/shippinglabel/${id}`}>
                                        <MenuItem className='flex items-center gap-2'>
                                            Download Shipping Label
                                        </MenuItem>
                                    </Link>
                                </MenuList>
                            </Menu>
                        </div>
                    </div>
                </div>

                {/* Main Content Grid */}
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-6' >
                    {/* Order Details Card */}
                    <div className='lg:col-span-2 bg-white rounded-xl shadow-md border border-gray-100 p-6' >
                        <div className='flex items-center justify-between mb-6 pb-4 border-b border-gray-200' >
                            <h2 className='font-[GilroyBold] text-xl text-gray-800' >Order Information</h2>
                            <span className={`inline-flex px-4 py-2 text-sm font-[GilroyMedium] rounded-full border capitalize ${getStatusColor(orderDetails?.orderStatus)}`}>
                                {orderDetails?.orderStatus || 'N/A'}
                            </span>
                        </div>
                        <div className='space-y-6' >
                            {/* Order ID and LR Number */}
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-4' >
                                <div className='bg-gray-50 rounded-lg p-4' >
                                    <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >Order ID</h4>
                                    <p className='font-[GilroyBold] text-lg text-gray-800' >#{orderDetails?.orderID || 'N/A'}</p>
                                </div>
                                <div className='bg-gray-50 rounded-lg p-4' >
                                    <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >LR Number</h4>
                                    <p className='font-[GilroyBold] text-lg text-gray-800' >{orderDetails?.lrno || 'N/A'}</p>
                                </div>
                            </div>

                            {/* Forwarding Number */}
                            <div className='bg-gray-50 rounded-lg p-4' >
                                <div className='flex items-center justify-between' >
                                    <div>
                                        <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >Forwarding Number</h4>
                                        <p className='font-[GilroyBold] text-lg text-gray-800' >{orderDetails?.forwardingNumber || '-'}</p>
                                    </div>
                                    {userProfile?.role === "admin" && orderDetails?.orderStatus === "pickedUp" && !orderDetails?.forwardingNumber && (
                                        <Button 
                                            onClick={generateForwardingNumber} 
                                            className='bg-black hover:bg-gray-800 text-white text-xs font-[GilroyMedium] px-4 py-2'
                                        >
                                            Generate Forwarding Number
                                        </Button>
                                    )}
                                </div>
                            </div>

                            {/* Shipment Details Grid */}
                            <div className='grid grid-cols-1 md:grid-cols-4 gap-4' >
                                <div className='bg-gray-50 rounded-lg p-4' >
                                    <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >Shipment Type</h4>
                                    <p className='font-[GilroyBold] text-lg text-gray-800' >{orderDetails?.d_mode || 'N/A'}</p>
                                </div>
                                <div className='bg-gray-50 rounded-lg p-4' >
                                    <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >Shipping Type</h4>
                                    <p className='font-[GilroyBold] text-lg text-gray-800' >{orderDetails?.shippingType || 'N/A'}</p>
                                </div>
                                <div className='bg-gray-50 rounded-lg p-4' >
                                    <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >Chargeable Weight</h4>
                                    <p className='font-[GilroyBold] text-lg text-gray-800' >{Math.ceil(orderDetails?.totalChargeableWeight || 0)} kgs</p>
                                </div>
                                <div className='bg-gray-50 rounded-lg p-4' >
                                    <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-1' >No of Boxes</h4>
                                    <p className='font-[GilroyBold] text-lg text-gray-800' >{getBoxes() || 0}</p>
                                </div>
                            </div>

                            {/* Receiver Details */}
                            <div className='bg-gray-50 rounded-lg p-4' >
                                <h4 className='font-[GilroyMedium] text-sm text-gray-600 mb-2' >Receiver Details</h4>
                                <p className='font-[GilroyMedium] text-base text-gray-800 leading-relaxed' >
                                    {orderDetails?.dropoff_location?.consignee || orderDetails?.dropoff_location?.companyName || 'N/A'},<br />
                                    {orderDetails?.dropoff_location?.address || ''},<br />
                                    {orderDetails?.dropoff_location?.city || ''}, {orderDetails?.dropoff_location?.region || ''} - {orderDetails?.dropoff_location?.zip || ''}
                                </p>
                            </div>
                        </div>
                        {/* POD Section */}
                        {orderDetails?.orderStatus === "delivered" && orderDetails?.pod && (
                            <div className='mt-6 pt-6 border-t border-gray-200'>
                                <div className='flex items-center justify-between mb-4'>
                                    <h3 className='font-[GilroyBold] text-lg text-gray-800'>Proof of Delivery</h3>
                                    <a 
                                        className='bg-black hover:bg-gray-800 py-2 px-4 font-[GilroyMedium] rounded-lg text-white transition-colors' 
                                        href={orderDetails?.pod} 
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        download
                                    >
                                        View POD
                                    </a>
                                </div>
                            </div>
                        )}

                        {/* Undelivered Details */}
                        {String(orderDetails?.orderStatus).toLowerCase() === 'undelivered' && (orderDetails?.undeliveredReason || orderDetails?.undeliveredPod) && (
                            <div className='mt-6 pt-6 border-t border-gray-200'>
                                <h3 className='font-[GilroyBold] text-lg text-gray-800 mb-4'>Undelivered Details</h3>
                                {orderDetails?.undeliveredReason && (
                                    <div className='bg-red-50 border border-red-200 rounded-lg p-4 mb-3'>
                                        <p className='text-sm text-red-800'><span className='font-[GilroyBold]'>Reason:</span> {orderDetails.undeliveredReason}</p>
                                    </div>
                                )}
                                {orderDetails?.undeliveredPod && (
                                    <a 
                                        className='bg-red-600 hover:bg-red-700 py-2 px-4 font-[GilroyMedium] rounded-lg text-white inline-block transition-colors' 
                                        href={orderDetails.undeliveredPod} 
                                        target='_blank' 
                                        rel='noreferrer'
                                    >
                                        View Undelivered Image
                                    </a>
                                )}
                            </div>
                        )}

                        {/* Upload POD Section */}
                        {orderDetails?.orderStatus === "delivered" && userProfile?.role === "admin" && (
                            <div className='mt-6 pt-6 border-t border-gray-200'>
                                <h3 className='font-[GilroyBold] text-lg text-gray-800 mb-4'>Upload POD</h3>
                                <form onSubmit={addPOD} className='flex items-start gap-4'>
                                    <input 
                                        type='file' 
                                        className='flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFB200]'
                                        accept='image/*,.pdf'
                                    />
                                    <Button 
                                        type='submit' 
                                        className='bg-[#FFB200] hover:bg-[#e6a000] text-black font-[GilroyMedium]'
                                        disabled={loadingPod}
                                    >
                                        {loadingPod ? "Uploading..." : "Upload POD"}
                                    </Button>
                                </form>
                            </div>
                        )}
                    </div>

                    {/* Status Timeline Card */}
                    <div className='lg:col-span-1 bg-white rounded-xl shadow-md border border-gray-100 p-6'>
                        <div className='flex items-center justify-between mb-6 pb-4 border-b border-gray-200'>
                            <h2 className='font-[GilroyBold] text-xl text-gray-800'>Order Status</h2>
                            {userProfile?.role === "admin" && (
                                <Button 
                                    onClick={handleUpdateModal} 
                                    className='bg-black hover:bg-gray-800 text-white text-xs font-[GilroyMedium] px-3 py-2'
                                >
                                    Update Status
                                </Button>
                            )}
                        </div>
                        <div className='max-h-[600px] overflow-y-auto space-y-4'>
                            {orderDetails?.orderActivity?.length > 0 ? (
                                orderDetails.orderActivity.map((activity, index) => (
                                    <div key={index} className='relative pl-6 pb-6 border-l-2 border-gray-200 last:border-l-0 last:pb-0'>
                                        <div className='absolute -left-2 top-0 w-4 h-4 bg-[#FFB200] rounded-full border-2 border-white'></div>
                                        <div className='bg-gray-50 rounded-lg p-4'>
                                            <div className='flex items-start justify-between mb-2'>
                                                <h4 className='font-[GilroyBold] text-sm text-gray-800 capitalize'>{activity?.status || 'N/A'}</h4>
                                                <span className='text-xs text-gray-500'>
                                                    {new Date(activity?.time).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                                                </span>
                                            </div>
                                            <p className='text-xs text-gray-600 mb-1'><span className='font-[GilroyMedium]'>Location:</span> {activity?.location || 'N/A'}</p>
                                            <p className='text-xs text-gray-600'><span className='font-[GilroyMedium]'>Remark:</span> {activity?.remark || 'N/A'}</p>
                                            <p className='text-xs text-gray-400 mt-2'>
                                                {new Date(activity?.time).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                                            </p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className='text-center py-8 text-gray-500'>
                                    <p className='text-sm'>No activity recorded yet</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ViewOrderDetails
